<template>
  <div class="kfc-wrap">
    <div class="bg-white">
      <!-- 公共头部导航栏 -->
      <Nav v-if="isEnter == false"></Nav>
      <!-- 公众号头部导航栏 -->
      <kfc-nav v-if="isEnter"></kfc-nav>
    </div>

    <!-- <div>asd465</div> -->

    <div class="body-content">
      <div class="top-hint">
        旧版肯德基将于9月1日关闭，请尽快将账号金额提现。申请新肯德基请前往：<span class="top-hint-span" @click="toOpenKfc()">品牌商城-应用开通-肯德基在线点餐</span>。详情请咨询客服
      </div>

      <div class="content-wrapper">
        <!-- 左侧菜单栏 -->
        <silde-nav></silde-nav>
        <div class="main-content">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setPlatformUuidKfc } from '@/utils/auth'
import SildeNav from '@/components/kfc/SildeNav.vue'
import Nav from '@/components/Nav.vue'
import KfcNav from '@/components/KfcNav.vue'
export default {
  name: 'Kfc',
  components: {
    SildeNav,
    Nav,
    KfcNav
  },
  data: function () {
    return {
      isEnter: true
    }
  },
  computed: {},
  mounted: function () {},
  methods: {
    toOpenKfc() {
      this.$router.push('/pc/open/application')
    }
  }
}
</script>
<style>
.bg-white {
  background-color: #fff;
}
.bg-fa {
  background-color: rgba(255, 250, 246, 0.5);
}
.table-wrapper .ivu-table .bg-fa td {
  background-color: rgba(255, 250, 246, 0.5) !important;
}
.table-wrapper .ivu-table .bg-white td {
  background-color: #fff;
}
.table-wrapper .ivu-table-header th {
  background-color: #fff !important;
}
.table-wrapper .ivu-table-header th .ivu-table-cell {
  font-size: 16px !important;
  color: #262626 !important;
  font-weight: normal;
}
.table-wrapper .ivu-table-tbody td .ivu-table-cell {
  font-size: 14px;
  color: #666666;
}
.table-wrapper .ivu-table-wrapper-with-border {
  border-radius: 4px;
  border-color: #e8e8e8 !important;
}
.table-wrapper .ivu-table::after,
.ivu-table::before {
  background-color: #e8e8e8 !important;
}
.table-wrapper .ivu-page-options-elevator input {
  top: -2px;
}
.table-wrapper .ivu-table th,
.table-wrapper .ivu-table td {
  height: 48px !important;
}
.ivu-date-picker-rel {
  margin: 6px 0;
}
.ivu-table {
  background: #ffffff;
  border: 1px solid #eeeeee;
  border-radius: 2px;
}
.table-wrapper .ivu-table-header th {
  background-color: #fcfaf8 !important;
}
.table-wrapper .ivu-table-header th .ivu-table-cell {
  color: #222222 !important;
}
.table-wrapper .ivu-table-wrapper-with-border {
  border: none;
}
.table-wrapper .ivu-table-wrapper-with-border {
  border-radius: 0px;
  border-color: #ffffff !important;
}
.search-wrap .search-label {
  padding-left: 20px;
  padding-right: 10px;
  font-size: 14px;
}
.search-wrap .search-rang-label {
  font-size: 14px;
  padding: 0 10px;
}
.search-wrap .search-btn {
  background: #d63036;
  color: #ffffff;
}
.margin-left-30 {
  margin-left: 30px;
}
.margin-left-20 {
  margin-left: 20px;
}
</style>
<style scoped>
.body-content {
  /* padding: 0 260px; */
  padding: 0 13%;
  background: #f5f5fa;
  display: flex;
  flex-wrap: wrap;
  min-width: 850px;
  min-height: 92%;
}

.top-hint {
  /* background-color: pink; */
  margin-top: 10px;
  color: red;
}
.top-hint-span {
  color: blue;
  text-decoration: underline;
  cursor: pointer;
}

/* @media screen and (max-width: 1750px) {
  .body-content {
    padding: 0 60px !important;
  }
} */

.content-wrapper {
  background: #fff;
  margin-top: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  padding-top: 20px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
}
.bg-white {
  width: 100%;
  background: #fff;
}
.main-content {
  flex: 1;
  padding: 20px 30px;
  min-width: 0;
}
>>> .ivu-btn-text:hover {
  background: #d63036;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/kfc/Index.vue